import { db } from './firebase';
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'

Vue.use(VueRouter);

require('./assets/main.less');

import Landing from './Landing.vue';
import RSVP from './RSVP.vue';
import Reserve from './Reserve.vue';
import Confirmation from './Confirmation.vue';
import Accomodations from './Accomodations.vue';

const routes = [
  {'path': '/', 'component': Landing, 'meta': {'title': 'Union of Aries'}},
  {'path': '/rsvp/:docId', 'component': Reserve, 'props': true, 'meta': {'title': 'RSVP | Union of Aries'}},
  {'path': '/confirm/:docId', 'component': Confirmation, 'props': true, 'meta': {'title': 'Confirmation | Union of Aries'}},
  {'path': '/rsvp', 'component': RSVP, 'meta': {'title': 'RSVP | Union of Aries'}},
  {'path': '/registry(.html)?', 'component': Landing, 'meta': {'toRegistry': true, 'title': 'Registry | Union of Aries'}},
  {'path': '*', 'component': Landing, 'meta': {'fourOhFour': true}},
];

const router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.toRegistry) {
    next('/#registry');
    return;
  } else if (to.meta.fourOhFour) {
    next('/');
    return;
  }
  document.title = to.meta.title
  next()
});

Vue.use(VueAnalytics, {
  id: 'UA-3075739-9',
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: route.path,
        title: route.meta.title,
        location: window.location.href
      }
    }
  }
});

new Vue({
  router
}).$mount("#app");

var css = '[v-cloak] > * { display: none !important; } [v-cloak] { display: none !important; }',
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

style.type = 'text/css';
if (style.styleSheet){
  style.styleSheet.cssText = css;
} else {
  style.appendChild(document.createTextNode(css));
}

head.appendChild(style);


// WEBPACK FOOTER //
// ./src/main.js